module.exports = __webpack_public_path__ + "static/img/cupshe_logo_2026.2141615e.png";